import PropTypes from 'prop-types';

import {
  Box,
  Dialog,
  IconButton,
  Typography,
  DialogContent,
} from '@mui/material';

import { getAPIUrl } from "src/config";

import Iconify from 'src/components/iconify';

export const PreviewAnnouncementDialog = (props) => {
  const { open, onClose, announcement } = props;

  if (!announcement) {
    return null;
  }

  const settings = announcement.settings ? JSON.parse(announcement.settings) : null;
  const fullscreenImage = settings?.fullscreen_image !== false; // true if undefined or true
  
  const imageUrl = announcement?.image_url;
  const finalImageUrl = imageUrl 
    ? imageUrl.includes('http') 
      ? imageUrl 
      : `${getAPIUrl()}${imageUrl}`
    : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible'
        }
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          overflow: 'visible',
          borderRadius: 3,
          position: 'relative',
          bgcolor: '#0A1929'
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: '100%',
            minHeight: 480,
            position: 'relative',
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#0A1929',
            ...(fullscreenImage && finalImageUrl ? {
              backgroundImage: `url(${finalImageUrl})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            } : {})
          }}
        >
          {!fullscreenImage && finalImageUrl && (
            <Box
              component="img"
              src={finalImageUrl}
              sx={{
                width: '100%',
                height: 280,
                objectFit: 'cover',
                display: 'block'
              }}
            />
          )}

          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: 'white',
              bgcolor: 'rgba(255, 255, 255, 0.1)',
              zIndex: 1,
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.2)'
              }
            }}
          >
            <Iconify icon="mdi:close" />
          </IconButton>

          <Box
            sx={{
              position: fullscreenImage ? 'absolute' : 'relative',
              bottom: 0,
              left: 0,
              right: 0,
              p: 3,
              pt: fullscreenImage ? 8 : 3,
              minHeight: !finalImageUrl ? 480 : 'auto',
              background: fullscreenImage 
                ? 'linear-gradient(to top, rgba(10, 25, 41, 0.95), rgba(10, 25, 41, 0))'
                : 'transparent',
              color: 'white',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flex: 1,
            }}
          >
            <Typography 
              variant="h5" 
              sx={{ 
                fontSize: '1.125rem',
                fontWeight: 600,
                mb: 1,
                maxWidth: '95%',
                margin: '0 auto 8px'
              }}
            >
              {announcement.title}
            </Typography>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: announcement.description }}
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                maxWidth: '95%',
                margin: '0 auto 16px',
                fontSize: '0.875rem',
                lineHeight: 1.6
              }}
            />
            {settings?.link && (
              <Box
                component="button"
                onClick={() => window.open(settings.link, '_blank')}
                sx={{
                  mt: 2,
                  py: 1.25,
                  px: 3,
                  border: 'none',
                  borderRadius: 1.5,
                  backgroundColor: settings?.link_color || '#2196f3',
                  color: 'white',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                  width: '90%',
                  maxWidth: 240,
                  '&:hover': {
                    opacity: 0.9
                  }
                }}
              >
                {settings?.link_text || 'Learn More'}
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

PreviewAnnouncementDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  announcement: PropTypes.object
}; 